import { FC } from 'react';

import { BottomPopup } from '@shared/components/BottomPopup';
import { Icon } from '@shared/components/icons';
import { checkIOS } from '@shared/utils/miscUtil';
import { RWebShare } from 'react-web-share';

import KakaoShareGiftButton from '../GiftCouponShareModal/KakaoShareGiftButton';

interface Props {
  openId: string;
  courtesyContent: string;
  linkUrl: string;
  onShare?: () => void;
}

export const GiftDeliveryShareModal: FC<Props> = function GiftDeliveryShareModal({
  openId,
  courtesyContent,
  linkUrl,
  onShare,
}) {
  const { ShareMessage, OtherApps } = Icon();

  const smsText = `${courtesyContent}\n\n▼ 답례품 받기 (배송지 입력) ▼\n${linkUrl}`;
  const smsContent = smsText.replace(/\n/g, '%0D%0A');

  const kakaoText = courtesyContent;

  return (
    <BottomPopup openId={openId}>
      <div className="w-screen rounded-t-2xl bg-white px-9 pb-12 pt-6">
        <h2 className="text-center text-lg font-bold text-gray-800">답례품 전달하기</h2>
        <p className="mt-1 text-center text-xs text-gray-500">
          받는 분이 직접11 배송지를 입력합니다
        </p>

        <div className="flex justify-center gap-6 pt-6">
          <a
            href={checkIOS() ? `sms:&body=${smsContent}` : `sms:?body=${smsContent}`}
            onClick={() => onShare?.()}
          >
            <div className="flex h-[70px] w-[80px] flex-col items-center justify-center gap-2">
              <ShareMessage className="h-full w-full" />
              <p className="text-sm font-bold text-gray-700">문자</p>
            </div>
          </a>

          <div
            className="flex h-[70px] w-[80px] flex-col items-center justify-center gap-2"
            onClickCapture={() => onShare?.()}
          >
            <KakaoShareGiftButton
              content={kakaoText}
              linkUrl={linkUrl}
              buttonTitle="배송지 입력하기"
            />
            <p className="text-sm font-bold text-gray-700">카카오톡</p>
          </div>

          <RWebShare
            data={{
              text: smsText,
              url: linkUrl,
              title: '답례품',
            }}
            onClick={() => onShare?.()}
          >
            <div className="flex h-[70px] w-[80px] flex-col items-center justify-center gap-2">
              <OtherApps />
              <p className="text-sm font-bold text-gray-700">다른 앱</p>
            </div>
          </RWebShare>
        </div>
      </div>
    </BottomPopup>
  );
};
